export const HEX_W = 215;
export const HEX_H = 240;
export const GAP = 10;
export const ROW_STRIDE = 195;
